<template>
  <div>
    <h1 class="h3 mb-3 font-weight-normal text-center">Kryptowährung hinzufügen</h1>
    <user-menu-add-form
      okButtonName="Krypto hinzufügen"
      :initFeed="this.newFeed"
      :initStep="3"
      :callbackExecuteAction="this.onStartAction"
      v-on:executeCancel="onExecuteCancel"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";

import UserMenuAddForm from "../User.Menu.AddForm.vue";

export default {
  name: "ProviderBitcoin",
  components: {
    UserMenuAddForm
  },
  data: function() {
    return {
      newFeed: {
        type: 2,
        url: "https://www.test.de",
        name: "Coins",
        category: ""
      }
    };
  },
  methods: {
    ...mapActions(["addUserFeed"]),
    onStartAction: function(feed) {
      this.addUserFeed(feed).then(() =>
        this.$router.push({
          name: "user",
          params: { category: feed.categoryId }
        })
      );
    },
    onExecuteCancel: function() {
      this.$emit("executeStop");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
